export const brands = ["All", "Leonard", "Cook"];

export const getBrand = (itemNumber) => {
  // Example item number: B-BARN-1024-800-C
  if (!itemNumber || !itemNumber.startsWith("B-")) {
    return "All";
  }

  const brand = itemNumber.split("-")[4];
  if (brand === "C") {
    return "Cook";
  }

  if (brand === "L") {
    return "Leonard";
  }

  if (!brand) {
    return "All";
  }

  return brand;
};

export const getSize = (itemNumber) => {
  // Example item number: B-BARN-1024-800-C
  if (!itemNumber) {
    return "n/a";
  }
  try {
    if (itemNumber.startsWith("B-")) {
      const fullSize = itemNumber.split("-")[2];
      const rawWidth = fullSize.substring(0, 2);
      const width = rawWidth.startsWith("0") ? rawWidth.substring(1) : rawWidth;
      const rawLength = fullSize.substring(2, 4);
      const length = rawLength.startsWith("0")
        ? rawLength.substring(1)
        : rawLength;
      return `${width}'x${length}'`;
    }

    if (itemNumber.startsWith("TRL") && itemNumber.includes("-")) {
      const fullSize = itemNumber.split("-")[1];
      const rawWidth = fullSize.substring(0, 2);
      const rawLength = fullSize.substring(2, 4);
      const length = rawLength.startsWith("0")
        ? rawLength.substring(1)
        : rawLength;
      const width = rawWidth.startsWith("0")
        ? rawWidth.substring(1)
        : rawWidth.substring(0, 1) + "." + rawWidth.substring(1);

      return `${width}'x${length}'`;
    }
  } catch (error) {
    console.log("Error in getSize function:", itemNumber);
    console.log(error);
  }

  return "";
};

/**
 * Rounds a price to the nearest number ending in 5 or 9 (retail pricing convention).
 * e.g. 1201 → 1199, 1204 → 1205, 93 → 95
 */
export const retailifyPrice = (price) => {
  const lastDigit = price % 10;

  if (lastDigit === 5 || lastDigit === 9) return price;

  const base = price - lastDigit;
  const sameDeckFive = base + 5;
  const sameDeckNine = base + 9;
  const prevDeckNine = base - 1;

  const candidates = [sameDeckFive, sameDeckNine, prevDeckNine];

  return candidates.reduce((closest, candidate) => {
    const closestDistance = Math.abs(closest - price);
    const candidateDistance = Math.abs(candidate - price);
    return candidateDistance <= closestDistance ? candidate : closest;
  });
};

export const calculateMonthlyPayment = (
  listPrice,
  term = 60, // 60 | 48 | 36
  isTrailer = false,
) => {
  if (listPrice <= 0) {
    return 0;
  }

  if (isTrailer) {
    if (listPrice < 3000) {
      // Flat multiplier — matches original behavior, compared against Hometowne Capital's portal
      return listPrice * 0.0475;
    }
    // 60 months @ 23.99% APR — aligned with Hometowne Capital's portal
    return getMonthlyPayment(0.2399, 60, listPrice);
  }

  // 72/60 months = 36% APR, 48 months = 47.5% APR, 36 months = 55% APR
  const rate = term >= 60 ? 0.36 : term === 48 ? 0.475 : 0.55;

  return getMonthlyPayment(rate, term, listPrice);
};

// export const calculateMonthlyPayment = (
//   listPrice,
//   term = 60 | 48 | 36,
//   isTrailer = false,
// ) => {
//   if (isTrailer) {
//     // chad and I compared to Hometowne Capitals portal and this number seemed to be pretty close to the dollar amount
//     return listPrice * 0.0475;
//   }

//   const rate = term === 60 ? 0.36 : term === 48 ? 0.475 : 0.55; // 60 months = 36% APR, 48 months = 47.5% APR, 36 months = 55% APR

//   return getMonthlyPayment(rate, 60, listPrice);
// };

/**
 * Calculates monthly payment using the Excel PMT formula.
 * @param {number} rate - Annual interest rate (e.g. 0.2399 for 23.99%)
 * @param {number} nper - Number of payment periods
 * @param {number} pv - Present value (loan principal)
 * @param {number} fv - Future value (default 0)
 * @param {number} type - 0 = end of period, 1 = beginning of period
 * @returns {number} Monthly payment (rounded, positive)
 */
function getMonthlyPayment(rate, nper, pv, fv = 0, type = 0) {
  const monthlyRate = rate / 12;

  if (monthlyRate === 0) {
    return Math.round((pv + fv) / nper);
  }

  const pvif = Math.pow(1 + monthlyRate, nper);

  // Correct PMT formula: rate * (PV*(1+r)^n + FV) / ((1+r)^n - 1)
  let pmt = (monthlyRate * (pv * pvif + fv)) / (pvif - 1);

  if (type === 1) {
    pmt = pmt / (1 + monthlyRate);
  }

  return retailifyPrice(Math.round(pmt));
}

// Example usage:
// const payment = calculateMonthlyPayment(300000, 5.5, 360); // 30-year mortgage at 5.5% APY
// console.log(payment); // Returns monthly payment amount

export const determineTypeDisplayName = (itemName, floorPlanNumber) => {
  let newType = "";
  if (itemName.toUpperCase().includes("CONDO")) {
    newType = "Dog Kennel";
  } else if (itemName.toUpperCase().includes("HIRK")) {
    newType = "Saltbox";
  } else if (itemName.toUpperCase().includes("HMP2")) {
    newType = "Vinyl A-Frame";
  } else if (itemName.toUpperCase().includes("LNTO")) {
    newType = "Lean To";
  } else if (itemName.toUpperCase().includes("LNTM")) {
    newType = "Metal Framed Lean To";
  } else if (itemName.toUpperCase().includes("MBY1")) {
    newType = "Barn";
  } else if (itemName.toUpperCase().includes("MNBE")) {
    newType = "Mini Barn";
  } else if (itemName.toUpperCase().includes("MNSB")) {
    newType = "Playhouse";
  } else if (itemName.toUpperCase().includes("PDM1")) {
    newType = "Wood A-Frame";
  } else if (itemName.toUpperCase().includes("PLBG")) {
    newType = "Playhouse";
  } else if (itemName.toUpperCase().includes("PLCC")) {
    newType = "Playhouse";
  } else if (itemName.toUpperCase().includes("PLTE")) {
    newType = "Metal Economy";
  } else if (itemName.toUpperCase().includes("PLTG")) {
    newType = "Golf Cart Ready";
  } else if (itemName.toUpperCase().includes("PLTS")) {
    newType = "Premium Metal";
  } else if (itemName.toUpperCase().includes("PLTW")) {
    newType = "Metal Sided Wood Framed";
  } else if (itemName.toUpperCase().includes("RITZ")) {
    newType = "The Ritz";
  } else if (itemName.toUpperCase().includes("OSCR")) {
    newType = "The Oscar";
  } else if (
    itemName.toUpperCase().includes("BARN") &&
    floorPlanNumber.toUpperCase().includes("000")
  ) {
    newType = "Barn";
  } else if (
    itemName.toUpperCase().includes("BARN") &&
    (floorPlanNumber.toUpperCase().includes("001") ||
      floorPlanNumber.startsWith("8"))
  ) {
    newType = "Lofted Barn";
  } else if (
    itemName.toUpperCase().includes("UTLY") &&
    !floorPlanNumber?.includes("001")
  ) {
    newType = "Utility";
  } else if (
    itemName.toUpperCase().includes("UTLY") &&
    floorPlanNumber.includes("001")
  ) {
    newType = "Lofted Utility";
  } else if (itemName.toUpperCase().includes("GRDN")) {
    newType = "Garden Shed";
  } else if (itemName.toUpperCase().includes("TOOL")) {
    newType = "Tool Shed";
  } else if (itemName.toUpperCase().includes("GNHS")) {
    newType = "Greenhouse";
  } else if (itemName.toUpperCase().includes("HNDY")) {
    newType = "Lofted Barn Handyman";
  } else if (itemName.toUpperCase().includes("BGAR")) {
    newType = "Lofted Barn Garage";
  } else if (itemName.toUpperCase().includes("UGAR")) {
    newType = "Utility Garage";
  } else if (itemName.toUpperCase().includes("SLIM")) {
    newType = "Slim Shed";
  } else if (
    itemName.toUpperCase().includes("COOP") ||
    itemName.toUpperCase().includes("MBYC")
  ) {
    newType = "Coop";
  } else if (
    itemName.includes("CNDO") ||
    itemName.includes("DOG") ||
    itemName.includes("CAT")
  ) {
    newType = "Pet";
  } else if (itemName.includes("PLANTER")) {
    newType = "Planter";
  } else if (itemName.includes("COOP")) {
    newType = "Chicken Coop";
  } else if (itemName.toUpperCase().includes("PLANTER")) {
    newType = "Planter";
  }

  console.log("Item Name: " + itemName);
  console.log("Type: " + newType);

  return newType;
};
